const DEFAULT_HOOKS = {
  onMessage: () => {},
}

class CCPWebSocket {
  /**
   * @param url
   * @param hooks
   */
  constructor(url, hooks) {
    this.url = url
    this.hooks = { ...DEFAULT_HOOKS, ...hooks }
    this.webSocket = undefined
    this.wsTimer = undefined
    this.wsHeartbeat = undefined
    this.isDisconnected = false
  }

  async init() {
    this.connect()
  }

  connect() {
    if (this.isDisconnected) {
      return
    }

    if (this.webSocket && this.webSocket.readyState !== WebSocket.CLOSED) {
      if (this.wsTimer) {
        clearInterval(this.wsTimer)
        this.wsTimer = undefined
      }
      return
    }
    this.webSocket = new WebSocket(this.url)
    this.webSocket.onopen = () => {
      this.webSocket.onmessage = event => {
        const message = JSON.parse(event.data)
        this.hooks.onMessage(message.event, message.data)
      }
      this.wsHeartbeat = setInterval(() => {
        this.webSocket.send('{"action":"heartbeat"}')
      }, 10000)
    }
    this.webSocket.onerror = () => {
      this.webSocket.close()
    }
    this.webSocket.onclose = () => {
      if (this.wsHeartbeat) {
        clearInterval(this.wsHeartbeat)
        this.wsHeartbeat = undefined
      }
      this.webSocket = undefined
      this.wsTimer = setInterval(() => {
        this.connect()
      }, 1000)
    }
  }
  disconnect() {
    this.isDisconnected = true

    if (this.wsHeartbeat) {
      clearInterval(this.wsHeartbeat)
      this.wsHeartbeat = undefined
    }

    if (this.wsTimer) {
      clearInterval(this.wsTimer)
      this.wsTimer = undefined
    }

    if (this.webSocket) {
      this.webSocket.close()
      this.webSocket = undefined
    }
  }
}

export default CCPWebSocket
